/**
 * Normalizes an SSN to its nine-digit storage format.
 * Both `123456789` and `123-45-6789` are accepted as input.
 */
export function normalizeSsn(value: unknown): string {
  return String(value ?? "").replace(/\D/g, "").slice(0, 9);
}

/**
 * Validates the structure of a US Social Security number.
 * Disallows invalid SSA area, group, and serial number ranges.
 */
export function isValidSsn(value: unknown): boolean {
  const ssn = normalizeSsn(value);
  if (!/^\d{9}$/.test(ssn)) return false;

  const area = Number(ssn.slice(0, 3));
  const group = ssn.slice(3, 5);
  const serial = ssn.slice(5);

  return (
    area !== 0 &&
    area !== 666 &&
    area < 900 &&
    group !== "00" &&
    serial !== "0000"
  );
}

export const SSN_VALIDATION_MESSAGE =
  "Enter a valid 9-digit SSN (for example, 123456789).";
